module.exports = __webpack_public_path__ + "img/common-arrow-prev.8543f631.svg";